import React from 'react';
import { useGame } from '../../context/GameContext';

function abbreviateName(name) {
  if (!name) return '?';
  if (name.length <= 5) return name;
  return name.slice(0, 4) + '.';
}

function getScoreClass(score) {
  if (score === null || score === undefined) return 'scoreboard__cell--empty';
  if (score <= -3) return 'scoreboard__cell--eagle';
  if (score < 0) return 'scoreboard__cell--birdie';
  if (score === 0) return 'scoreboard__cell--par';
  if (score <= 10) return 'scoreboard__cell--bogey';
  return 'scoreboard__cell--double-bogey';
}

function ScoreBoard() {
  const { state } = useGame();
  const { players, playerOrder, gameState } = state;
  const totalRounds = gameState.totalRounds || 9;
  const holes = Array.from({ length: totalRounds }, (_, i) => i + 1);

  const totals = {};
  playerOrder.forEach((pid) => {
    const scores = players[pid]?.scores?.roundScores || [];
    totals[pid] = scores.reduce((sum, s) => sum + (s ?? 0), 0);
  });
  const totalValues = Object.values(totals);
  const minTotal = Math.min(...totalValues);
  const maxTotal = Math.max(...totalValues);
  const hasScores = totalValues.some((t) => t !== 0);

  return (
    <div className="scoreboard">
      <table className="scoreboard__table">
        <thead>
          <tr>
            <th className="scoreboard__corner"></th>
            {holes.map((h) => (
              <th key={h} className="scoreboard__hole">{h}</th>
            ))}
            <th className="scoreboard__total-header">TOT</th>
          </tr>
        </thead>
        <tbody>
          {playerOrder.map((pid) => {
            const player = players[pid];
            if (!player) return null;
            const scores = player.scores?.roundScores || [];
            let runningTotal = 0;

            const isLeader = hasScores && totals[pid] === minTotal;
            const isTrailing = hasScores && totals[pid] === maxTotal && minTotal !== maxTotal;

            return (
              <tr key={pid} className={isLeader ? 'scoreboard__row--leader' : ''}>
                <td className="scoreboard__name">
                  {abbreviateName(player.displayName)}
                </td>
                {holes.map((h, i) => {
                  const score = scores[i];
                  const hasScore = score !== undefined && score !== null;
                  if (hasScore) runningTotal += score;
                  return (
                    <td key={h} className={`scoreboard__cell ${getScoreClass(score)}`}>
                      <span className="scoreboard__cell-inner">
                        {hasScore ? score : '–'}
                      </span>
                    </td>
                  );
                })}
                <td className={`scoreboard__total ${isLeader ? 'scoreboard__total--leader' : ''} ${isTrailing ? 'scoreboard__total--trailing' : ''}`}>
                  {runningTotal}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ScoreBoard;
